export default {
  methods: {
    generateToken({
      number,
      month,
      year,
      firstName,
      lastName,
      securityCode
    }) {
      return new Promise((resolve, reject) => {
        try {
          Iugu.setAccountID(BulldeskSettings.iuguAccountId);

          console.log('test mode', BulldeskSettings.env !== 'production');
          Iugu.setTestMode(BulldeskSettings.env !== 'production');

          const cc = Iugu.CreditCard(
            number,
            month,
            year,
            firstName,
            lastName,
            securityCode,
          );

          const handler = (response) => {
            if (response.errors) {
              console.error(response.errors);

              return reject(response.errors);
            }

            const token = response.id;

            return resolve(token);
          };

          Iugu.createPaymentToken(cc, handler);
        } catch (error) {
          console.error(error);

          return reject(error);
        }
      });
    }
  },
};
